import { render, staticRenderFns } from "./RightColumnQnASettings.vue?vue&type=template&id=117e1908&scoped=true"
import script from "./RightColumnQnASettings.vue?vue&type=script&lang=js"
export * from "./RightColumnQnASettings.vue?vue&type=script&lang=js"
import style0 from "./RightColumnQnASettings.vue?vue&type=style&index=0&id=117e1908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117e1908",
  null
  
)

export default component.exports